/** Google Calendar event colorId values (1–11) and UI swatches. */
/** Official-ish palette matching Google Calendar event colors. */
export const GOOGLE_CALENDAR_EVENT_COLORS = [
    { id: '1', name: 'Lavender', nameTh: 'ม่วงอ่อน', background: '#a4bdfc', foreground: '#1d1d1d' },
    { id: '2', name: 'Sage', nameTh: 'เขียวอ่อน', background: '#7ae7bf', foreground: '#1d1d1d' },
    { id: '3', name: 'Grape', nameTh: 'ม่วง', background: '#dbadff', foreground: '#1d1d1d' },
    { id: '4', name: 'Flamingo', nameTh: 'ชมพู', background: '#ff887c', foreground: '#1d1d1d' },
    { id: '5', name: 'Banana', nameTh: 'เหลือง', background: '#fbd75b', foreground: '#1d1d1d' },
    { id: '6', name: 'Tangerine', nameTh: 'ส้ม', background: '#ffb878', foreground: '#1d1d1d' },
    { id: '7', name: 'Peacock', nameTh: 'ฟ้าเขียว', background: '#46d6db', foreground: '#1d1d1d' },
    { id: '8', name: 'Graphite', nameTh: 'เทา', background: '#e1e1e1', foreground: '#1d1d1d' },
    { id: '9', name: 'Blueberry', nameTh: 'น้ำเงิน', background: '#5484ed', foreground: '#ffffff' },
    { id: '10', name: 'Basil', nameTh: 'เขียว', background: '#51b749', foreground: '#ffffff' },
    { id: '11', name: 'Tomato', nameTh: 'แดง', background: '#dc2127', foreground: '#ffffff' },
];
export function normalizeGoogleCalendarColorId(raw) {
    const id = String(raw ?? '').trim();
    if (!/^(?:[1-9]|1[01])$/.test(id))
        return '';
    return id;
}
export function getGoogleCalendarEventColor(raw) {
    const id = normalizeGoogleCalendarColorId(raw);
    if (!id)
        return null;
    return GOOGLE_CALENDAR_EVENT_COLORS.find((c) => c.id === id) || null;
}
//# sourceMappingURL=calendar-colors.js.map